import React, { useState } from "react";
import CommonDataTable from "../../../components/ui/table/CommonTable";
import { useGetMealsQuery } from "../../../featureSlice/mealSliceApi";
import EditIcon from "../../../svg/EditIcon";
import DeleteIcon from "../../../svg/DeleteIcon";

const MealTable = ({ onEditClick,onDeleteClick }) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { data } = useGetMealsQuery({
    page,
    limit: rowsPerPage,
  });
  const columns = [
    { name: "Meal ID", selector: (row) => row?.meal_id },
    { name: "Meal Name", selector: (row) => row?.meal_name },
    {
      name: "Shift",
      cell: (row) => (
        <span
          className={` px-2 py-1 bg-lightSecondary text-primary rounded font-medium`}
        >
          {row?.shift}
        </span>
      ),
    },
    {
      name: "Start Time ",
      cell: (row) => <span className=" px-2 py-1  ">{row?.start_time}</span>,
    },
    { name: "End Time ", selector: (row) => row?.end_time },
    // { name: "Gap", selector: (row) => row?.gap },
    { name: "Description", selector: (row) => row?.description },
    {
      name: "Action",
      cell: (row) => (
        <div className="flex gap-3 items-center justify-start">
          <button
            onClick={() => {
              onEditClick(row);
            }}
          >
            <EditIcon />
          </button>

          <button
            className="p-2"
            onClick={(e) => {
              onDeleteClick(row?.id);
            }}
          >
            <DeleteIcon />
          </button>
        </div>
      ),
    },
  ];

  const rows = data?.data || [];
  return (
    <div>
      <CommonDataTable
        columns={columns}
        data={rows}
        pagination
        paginationServer
        paginationTotalRows={data?.meta_data?.total_records || 0}
        onChangePage={(page) => setPage(page)}
        onChangeRowsPerPage={(newLimit) => {
          setRowsPerPage(newLimit);
          setPage(1);
        }}
      />
    </div>
  );
};

export default MealTable;
